namespace Portico.Models.Setup {

    export interface IDemo {
		portal: Portal;
		template: DataValue;
		brand: DataValue;
		pharma: DataValue;
		primary: DataValue;
		secondary: DataValue;
		square: boolean;
		shadow: boolean;
		logo: DataValue;
		logoFile: any;
	}

	export class Demo implements IDemo {
		portal: Portal;
		template: DataValue;
		brand: DataValue;
		pharma: DataValue;
		primary: DataValue;
		secondary: DataValue;
		square: boolean;
		shadow: boolean;
		logo: DataValue;
		logoFile: any;

		constructor(obj?: IDemo) {
			this.portal = null;
			this.template = null;
			this.brand = null;
			this.pharma = null;
			this.primary = null;
			this.secondary = null;
			this.square = false;
			this.shadow = false;
			this.logo = null;
			this.logoFile = null;

            if (obj) {
				if (obj.portal) {
					this.portal = new Portal(obj.portal);
				}

				if (obj.template) {
					this.template = new DataValue(obj.template);
				}

				if (obj.brand) {
					this.brand = new DataValue(obj.brand);
				}

				if (obj.pharma) {
					this.pharma = new DataValue(obj.pharma);
				}

				if (obj.primary) {
					this.primary = new DataValue(obj.primary);
				}

				if (obj.secondary) {
					this.secondary = new DataValue(obj.secondary);
				}

				this.square = obj.square;
				this.shadow = obj.shadow;

				if (obj.logo) {
					this.logo = new DataValue(obj.logo);
				}

				this.logoFile = obj.logoFile;
            }
        }
    }
}